module.exports = "https://cwa.roocdn.com/_next/static/favicon-32x32.c9dae355.png";